module.exports = __webpack_public_path__ + "img/f920d09e6f0a5cda0c3a14f77253300b.e187a6cc.jpg";